import React, { useState } from 'react';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button, Checkbox, Collapse, FormControlLabel, Paper, Typography } from '@mui/material';

import { InternalRoom, InternalService } from '~/services/AccommodationService';

import { titleCase } from '~/utils/stringUtils';

import SupplierRoomsForInternalRoomList from './SupplierRoomsForInternalRoomList';

interface Props {
  room: InternalRoom;
  isSelected: boolean;
  internalService: InternalService;
  onSelect: (internalRoomId: string, selected: boolean) => void;
}

export default function InternalRoomElement({ room, isSelected, internalService, onSelect }: Props) {
  const [isSourceRoomsExpanded, setIsSourceRoomsExpanded] = useState(false);

  return (
    <Paper
      variant="outlined"
      sx={{
        p: 2,
        backgroundColor: !isSelected ? 'grey.100' : undefined,
        borderColor: isSelected ? 'info.light' : undefined,
      }}
    >
      <FormControlLabel
        checked={isSelected}
        onChange={() => onSelect(room.id, !isSelected)}
        control={<Checkbox />}
        label={room.name}
        componentsProps={{ typography: { variant: 'h6' } }}
      />
      <Typography sx={{ m: '1rm' }}>
        <strong>Internal Service:</strong> {titleCase(internalService)}
      </Typography>
      <Button
        size="small"
        variant="text"
        onClick={() => setIsSourceRoomsExpanded(!isSourceRoomsExpanded)}
        endIcon={isSourceRoomsExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        sx={{ mt: 1 }}
      >
        {isSourceRoomsExpanded ? 'Hide' : 'Show'} supplier rooms
      </Button>
      <Collapse in={isSourceRoomsExpanded}>
        <SupplierRoomsForInternalRoomList internalRoomId={room.id} isExpanded={isSourceRoomsExpanded} showNameInTitle />
      </Collapse>
    </Paper>
  );
}
